import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountStatusPaymentMethodStatusDto } from '@well/domain';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { contactInfoSignupStepUrl, subscriptionSignupStepUrl } from '@well/navigation';
import { PaymentMethodPendingStepService } from './payment-method-pending-step.service';

@Component({
  selector: 'signup-payment-method-pending-step',
  templateUrl: './payment-method-pending-step.component.html',
  styleUrls: ['./payment-method-pending-step.component.scss'],
})
export class PaymentMethodPendingStepComponent implements OnInit, OnDestroy{

  currentStatus: AccountStatusPaymentMethodStatusDto | null = null;
  private legalEntityUuid: string | null = null;
  private unsubscribe: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private paymentMethodPendingStepService: PaymentMethodPendingStepService) {

  }

  ngOnInit(): void {
    this.legalEntityUuid = this.activatedRoute.snapshot.params['legalEntityUuid'];
    this.subscribeToActivatedRouteChanges();
  }

  onRetryPayment(){
    this.router.navigate(subscriptionSignupStepUrl(this.legalEntityUuid));
  }

  onConfirmPayment(){
    this.router.navigate(contactInfoSignupStepUrl(this.legalEntityUuid));
  }

  onMissingPendingPayment(){
    this.paymentMethodPendingStepService.getCurrentPaymentMethodVO()
      .subscribe((resource) => {
        if(resource.data?.uuid){
          this.router.navigate(contactInfoSignupStepUrl(this.legalEntityUuid));
        }
        else{
          this.router.navigate(subscriptionSignupStepUrl(this.legalEntityUuid));
        }
      })
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
  }

  private subscribeToActivatedRouteChanges(){
    this.activatedRoute.params.subscribe((params) => {
      this.legalEntityUuid = params['legalEntityUuid'];
    })
  }

}
